import { ScrollCaptain } from 'scroll-captain';

class TextMedia {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-textmedia',
            translationsAttr: 'data-research-ai-landingpage-textmedia-translations',
            containerValue: 'container',
            userIconValue: 'user-icon',
            userTextValue: 'user-text',
            aiIconValue: 'ai-icon',
            aiTextValue: 'ai-text',
            aiDiagramValue: 'ai-diagram',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$textMedia = element;
        this.$language = this.$textMedia.querySelector(`[${ this.settings.translationsAttr }]`);
        this.onscrollAnimation = null;
        this.keyframeAnimation = null;

        // Options
        this.translationsData = this.$language?.getAttribute(this.settings.translationsAttr) || '';
        this.translations = [];
    }

    initialize() {
        this.initAnimation();
        if (this.$language && this.translationsData !== '') {
            this.translations = JSON.parse(this.translationsData);
            this.cycleTextWithAnimation(this.$language, this.translations);
        }
    }

    cycleTextWithAnimation(element, texts) {
        let currentIndex = 0;

        // Initialize the first visible text container
        let visibleTextContainer = document.createElement('span');
        visibleTextContainer.classList.add('researchAiLandingpage-textMedia__languageSwitch');
        visibleTextContainer.innerText = texts[currentIndex];
        element.appendChild(visibleTextContainer);

        // Add the second container, which is initially outside the visible area
        currentIndex = (currentIndex + 1) % texts.length;
        let upcomingTextContainer = document.createElement('span');
        upcomingTextContainer.classList.add('researchAiLandingpage-textMedia__languageSwitch');
        upcomingTextContainer.innerText = texts[currentIndex];
        upcomingTextContainer.style.transform = 'translateY(100%)';
        element.appendChild(upcomingTextContainer);

        setInterval(() => {
            // Animate the visible text upwards
            visibleTextContainer.style.animation = 'slideUp 1s forwards';

            // Animate the new text upwards, so it comes into the visible area
            upcomingTextContainer.style.transform = ''; // Remove the transform so the animation applies
            upcomingTextContainer.style.animation = 'slideDown 1s forwards';

            // After the animation is complete, remove the old container
            setTimeout(() => {
                element.removeChild(visibleTextContainer);
                // The new visible container is now the previously "upcoming" container
                visibleTextContainer = upcomingTextContainer;

                // Prepare the next text container
                currentIndex = (currentIndex + 1) % texts.length;
                upcomingTextContainer = document.createElement('span');
                upcomingTextContainer.classList.add('researchAiLandingpage-textMedia__languageSwitch');
                upcomingTextContainer.innerText = texts[currentIndex];
                upcomingTextContainer.style.transform = 'translateY(100%)'; // Start again from the bottom
                element.appendChild(upcomingTextContainer);
            }, 1000); // This should match the duration of the slide-up animation
        }, 2000);
    }

    initAnimation() {
        const defaultOptions = {
            onscroll: true,
            duration: 0,
            easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
        };

        this.onscrollAnimation = new ScrollCaptain(this.$textMedia, {
            initAttr: this.settings.initAttr,
            animateSpeechbubble: {
                targetSuffix: this.settings.containerValue,
            },
            breakpoints: {
                768: {
                    animateSpeechbubble: {
                        ...defaultOptions,
                        translateY: { 0: 100, 100: -100 },
                    },
                },
            },
        });

        if (window.innerWidth >= 768) {
            this.keyframeAnimation = new ScrollCaptain(this.$textMedia, {
                initAttr: this.settings.initAttr,
                bottom: '-40%',
                animateUserIcon: {
                    targetSuffix: this.settings.userIconValue,
                    scale: { 0: 0, 100: 1 },
                    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    duration: 0.2,
                    resetOnScrollDown: false,
                },
                animateUserText: {
                    targetSuffix: this.settings.userTextValue,
                    translateY: { 0: 50, 100: 0 },
                    opacity: { 0: 0, 100: 1 },
                    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    duration: 0.5,
                    delay: 0.3,
                    resetOnScrollDown: false,
                },
                animateAiIcon: {
                    targetSuffix: this.settings.aiIconValue,
                    scale: { 0: 0, 100: 1 },
                    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    duration: 0.2,
                    delay: 0.8,
                    resetOnScrollDown: false,
                },
                animateAiText: {
                    targetSuffix: this.settings.aiTextValue,
                    translateY: { 0: 50, 100: 0 },
                    opacity: { 0: 0, 100: 1 },
                    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    duration: 0.5,
                    delay: 1,
                    resetOnScrollDown: false,
                },
                animateDiagram: {
                    targetSuffix: this.settings.aiDiagramValue,
                    translateY: { 0: 50, 100: 0 },
                    opacity: { 0: 0, 100: 1 },
                    easing: 'cubic-bezier(0.33, 1, 0.68, 1)',
                    duration: 0.4,
                    delay: 1.4,
                    resetOnScrollDown: false,
                },
            });
        }
    }
}

export { TextMedia };
